$(document).ready(function() {
  /*if ($(window).height() < 500) {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }*/

  // PRODUCT TILES FADE IN PRODUCT INFO
    
  $(".item").hover(function(){
      if ($(window).width() > 640) {
        $( this).find(".image img").attr("src", $(this).find(".image img").attr("variant-src")) ;
        $( this).find(".title").addClass("active") ;
      }
    }, function() {
      if ($(window).width() > 640) {
        $( this).find(".image img").attr("src", $(this).find(".image img").attr("product-src")) ;
        $( this).find(".title").removeClass("active") ;
      }
    }
  );
  $('#home .item').hover(function(){
        if($(window).width() > 960){
          $(this).find(".product-loop-icon-organic").show();  
          $(this).find(".smartwishlist").show();  
        }
        }, function() {
        if($(window).width() > 960){
          $(this).find(".product-loop-icon-organic").hide();
          $(this).find(".smartwishlist").hide();  
        }
    }
  );
});